module.exports = __webpack_public_path__ + "img/todo.049973ef.svg";